export const opEstadoCivil = [
    { label: 'Casada',
        value: 1 },
    { label: 'Casado',
        value: 2 },
    { label: 'Solteiro',
        value: 12 },
    { label: 'Viuvo',
        value: 7 },
    { label: 'Separado',
        value: 8 },
    { label: 'Divorciado',
        value: 19 },
    { label: 'Amigado',
        value: 40 },
    { label: 'Solteira',
        value: 5 }
];

export const opPagamento = [
    { label: 'Boleto',
        value: 1 },
    { label: 'Cartão',
        value: 7 },
    { label: 'EDP ESCELSA - Conta de Luz',
        value: 8 }
];

export const opMensalidade = [
    { label: 'Mensal',
        value: 'M' },
    { label: 'Anual',
        value: 'A' },
    { label: '4 Anos',
        value: '4' },
    { label: '4 Anos',
        value: 'AT' }
];